import React, { useEffect } from "react";
import "./DashBoard.css";
import {
  Link,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Groups from "./Groups";
import Processes from "./Processes";
import Configurations from "./Configurations";
import EmailConfigurationPage from "./EmailConfigurationPage";
import Models from "./Models";
import { useProcessContext } from "../../context/ProcessContext";
import Records from "./Records";

const Dashboard = () => {
  const { checkLoginStatus } = useProcessContext();
  const location = useLocation();
  const navigate = useNavigate();

  // Save the current dashboard route in session storage whenever it changes
  useEffect(() => {
    if (location.pathname.startsWith("/dashboard")) {
      sessionStorage.setItem("lastVisitedDashboardRoute", location.pathname);
    }
  }, [location]);

  // On component mount, redirect to the last visited dashboard route if it exists
  useEffect(() => {
    const lastVisitedRoute = sessionStorage.getItem(
      "lastVisitedDashboardRoute"
    );
    if (lastVisitedRoute && lastVisitedRoute !== "/dashboard") {
      navigate(lastVisitedRoute);
    }
  }, [navigate]);

  // useEffect for token validation
  useEffect(() => {
    checkLoginStatus();
  }, [location.pathname]);

  return (
    <div className="dashBoard">
      <div className="">
        <div className="donor_row">
          <div className="donor_dash_left">
            <div className="donor_dash_side">
              <div className="donor_side_menu">
                <ul className="donor_menu">
                  <li>
                    <Link
                      to="/dashboard/processes"
                      className={` ${
                        location.pathname === "/dashboard/processes"
                          ? "active"
                          : ""
                      }`}
                    >
                      {" "}
                      Processes{" "}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard/groups"
                      className={` ${
                        location.pathname === "/dashboard/groups"
                          ? "active"
                          : ""
                      }`}
                    >
                      {" "}
                      User Roles{" "}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard/configurations"
                      className={` ${
                        location.pathname.startsWith(
                          "/dashboard/configurations"
                        )
                          ? // location.pathname === "/dashboard/configurations"
                            "active"
                          : ""
                      }`}
                    >
                      {" "}
                      Configurations{" "}
                    </Link>
                    {/* ========================= */}
                    {location.pathname.startsWith(
                      "/dashboard/configurations"
                    ) && (
                      <div className="donor_side_menu">
                        <ul className="donor_menu">
                          <li>
                            <Link
                              to="/dashboard/configurations/hutch"
                              className={` ${
                                location.pathname ===
                                "/dashboard/configurations/hutch"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              {" "}
                              Hutch Configuration{" "}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/dashboard/configurations/email"
                              className={` ${
                                location.pathname ===
                                "/dashboard/configurations/email"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              {" "}
                              Email Configuration{" "}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/dashboard/configurations/model"
                              className={` ${
                                location.pathname ===
                                "/dashboard/configurations/model"
                                  ? "active"
                                  : ""
                              }`}
                              // style={{ cursor: "not-allowed" }}
                            >
                              {" "}
                              Model Configuration{" "}
                            </Link>
                          </li>
                          <li className="ps-4">
                            <Link
                              to="/dashboard/configurations/model/records"
                              className={` ${
                                location.pathname ===
                                "/dashboard/configurations/model/records"
                                  ? "active"
                                  : "d-none"
                              } `}
                              // style={{ cursor: "not-allowed" }}
                            >
                              {" "}
                              Model Records{" "}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    )}
                    {/* ========================= */}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard/processes" />} />
            <Route path="/processes" element={<Processes />} />
            {/* <Route path="/dashboard/configurations" element={<Navigate to="/dashboard/configurations/hutch" />} /> */}
            <Route path="/groups" element={<Groups />} />
            {/* ====================== */}
            {/* Redirect to /hutch by default if /dashboard/configurations is accessed */}
            <Route path="/configurations/*" element={<Outlet />}>
              <Route
                index
                element={<Navigate to="/dashboard/configurations/hutch" />}
              />
              <Route path="email" element={<EmailConfigurationPage />} />
              <Route path="model" element={<Models />} />
              <Route path="model/records" element={<Records />} />
              <Route path="hutch" element={<Configurations />} />
            </Route>
            {/* ====================== */}
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
